module.exports = __webpack_public_path__ + "components/incentive/static/surf-icon-48d190849c57abe3ad4e6527ad4263f1.svg";